'use client';

import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

const data = [
  { week: 'Sem 1', empaques: 620, transporte: 840, electronica: 390, salud: 520 },
  { week: 'Sem 2', empaques: 710, transporte: 920, electronica: 450, salud: 490 },
  { week: 'Sem 3', empaques: 680, transporte: 870, electronica: 510, salud: 560 },
  { week: 'Sem 4', empaques: 750, transporte: 1050, electronica: 580, salud: 530 },
  { week: 'Sem 5', empaques: 820, transporte: 980, electronica: 640, salud: 610 },
  { week: 'Sem 6', empaques: 890, transporte: 1120, electronica: 720, salud: 580 },
  { week: 'Sem 7', empaques: 940, transporte: 1080, electronica: 810, salud: 650 },
  { week: 'Sem 8', empaques: 1010, transporte: 1240, electronica: 920, salud: 700 },
];

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-[#d2d2d7] rounded-xl p-3 shadow-xl text-xs">
      <p className="font-semibold text-black mb-2">{label}</p>
      {payload.map((entry: any) => (
        <div key={`tooltip-${entry.dataKey}`} className="flex items-center justify-between gap-6 mb-1">
          <span className="text-[#6e6e73] flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full" style={{ backgroundColor: entry.color }} />
            {entry.name}
          </span>
          <span className="font-mono-data font-semibold text-black">
            {entry.value.toLocaleString('es-CO')}
          </span>
        </div>
      ))}
    </div>
  );
};

export default function DemandChart() {
  return (
    <ResponsiveContainer width="100%" height={240}>
      <AreaChart data={data} margin={{ top: 5, right: 10, left: -20, bottom: 0 }}>
        <defs>
          <linearGradient id="gradEmpaques" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#ffffff" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#ffffff" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="gradTransporte" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#a1a1a6" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#a1a1a6" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="gradElectronica" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#6e6e73" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#6e6e73" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="gradSalud" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#d2d2d7" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#d2d2d7" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.08)" />
        <XAxis
          dataKey="week"
          tick={{ fill: 'rgba(255,255,255,0.4)', fontSize: 11 }}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          tick={{ fill: 'rgba(255,255,255,0.4)', fontSize: 11 }}
          axisLine={false}
          tickLine={false}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend
          wrapperStyle={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', paddingTop: '12px' }}
        />
        <Area type="monotone" dataKey="empaques" name="Empaques" stroke="#ffffff" strokeWidth={1.5} fill="url(#gradEmpaques)" />
        <Area type="monotone" dataKey="transporte" name="Transporte" stroke="#a1a1a6" strokeWidth={1.5} fill="url(#gradTransporte)" />
        <Area type="monotone" dataKey="electronica" name="Electrónica" stroke="#6e6e73" strokeWidth={1.5} fill="url(#gradElectronica)" />
        <Area type="monotone" dataKey="salud" name="Salud" stroke="#d2d2d7" strokeWidth={1.5} fill="url(#gradSalud)" />
      </AreaChart>
    </ResponsiveContainer>
  );
}